export default "__VITE_ASSET__298a8a8b__"